import {
  DeleteAutoFacParticipant,
  DeleteAutoFacParticipantVariables,
} from "_graphql/mutation/__generated__/DeleteAutoFacParticipant";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { deleteAutoFacParticipant } from "_graphql/visal/mutations/auto-fac";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RemoveContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    DeleteAutoFacParticipant,
    DeleteAutoFacParticipantVariables
  >(deleteAutoFacParticipant, {
    refetchQueries: ["GetAutoFacParticipants"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        autoFacParticipantId: searchParams?.id || "",
      },
    }).then(({ data }) => {
      if (data?.deleteAutoFacParticipant) {
        toast.success("Participant Removed Successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Could not remove participant");
      }
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Remove Participant"
      cancelText="No, Don't Remove Participant"
      description="This action would completely remove Participant details from this configuration"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {loading ? "Removing Participant..." : "Remove Participant"}
          </button>
        </>
      )}
    />
  );
}
